import { useMutation } from '@tanstack/react-query';

import {
  checkV3Eligibility,
  type EngineV3EligibilityResponse
} from '~/api/runtimeService';

type CheckV3EligibilityVariables = {
  realm: string;
  pipelineId: string;
};

export function useCheckV3Eligibility() {
  return useMutation<
    EngineV3EligibilityResponse,
    Error,
    CheckV3EligibilityVariables
  >({
    mutationFn: checkV3Eligibility
  });
}

